import React from 'react';
import './CaseSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const CaseSingle = () => {

  // Get case study details passed via router state
  const location = useLocation();
  const caseStudy = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={caseStudy.title} page={"Case Single"} />

      <section className='case-single page-single'>

        <div className='case-info page-info'>

          {/* Case Study Image */}
          <div className='image'>
            <img src={caseStudy.image} alt={caseStudy.title} />
          </div>

          <div className='content'>

            {/* Case Study Title */}
            <h3 className='main-heading'>{caseStudy.title}</h3>

            {/* Case Study Description */}
            {caseStudy.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Case Study Image Gallery */}
            <Lightbox images={caseStudy.gallery} />

            {/* Case Study Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Challenges Faced:</h3>

              <p>Key obstacles encountered during the development and growth of a startup:</p>

              {/* List of Case Study Challenges */}
              <ul>
                {caseStudy.challenges.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Case Study Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Solutions Provided:</h3>

              <p>We addressed these challenges with the following tailored solutions:</p>

              {/*Case Study Solutions List */}
              <ul>
                {caseStudy.solutions.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Case Study Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Results & Impact:</h3>

              <p>A detailed breakdown of the outcomes and key achievements from the project:</p>

              {/* Case Study Results */}
              <ul>
                {caseStudy.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Case Study details */}
        <PageSidebar
          heading={'Case Study'}
          details={caseStudy.details}
        />

      </section>

    </> 
  );
}

export default CaseSingle;